import {constant} from './const.js'

export default {
  install: (app) => {
    app.config.globalProperties.$config = constant
  },
}
